import DataTableV2PaginatedMixin from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated'

export default {
  name: 'PriceItemDataTable',
  mixins: [DataTableV2PaginatedMixin],

  props: {
    priceListId: String
  },

  data () {
    return {
      // Set as hardcoded filter the priceListId
      implicitFilters: [{ field: 'priceListId', operator: 'EQUALS', value: this.priceListId }]
    }
  },

  computed: {
    // overwrite persistency route for filters and table settings
    dumpRoute () {
      return `/api/${this.applicationId}/workspace/${this.workspaceId}/tracker/${this.trackerTypeId}/priceListId/${this.priceListId}`
    },
    filterRoute () {
      return this.dumpRoute
    }
  },

  methods: {
    createItem (itemDTO) {
      this.itemDTO = this.setContext(Object.assign({}, itemDTO))
      this.$router.agilis.newTracker(this.trackerTypeId, this.priceListId) // TODO: make it generic: handle any query params
    },

    // Override copy method
    copyItem (item, event) {
      const itemDTO = Object.assign({}, item, { id: null, sequenceNumber: null })

      // Remove blacklisted field
      if (this.dataTableConfiguration.copyFieldExclusions && Array.isArray(this.dataTableConfiguration.copyFieldExclusions)) {
        this.dataTableConfiguration.copyFieldExclusions.forEach((field) => {
          delete itemDTO[field]
        })
      }

      this.$router.agilis.copyTracker({
        trackerTypeId: this.trackerTypeId,
        data: itemDTO,
        parentTrackerId: this.priceListId
      })
    }
  }
}
